/**
 * 教师考勤相关 API 模块
 * 创建于 2026-07-08
 */
import axios from "axios";
import { BaseApiUrl } from "./base";

const base = BaseApiUrl;

// ========== 后台查询接口 ==========

/**
 * 获取教师月度考勤汇总列表（分页）
 */
export const getTeacherMonthDetail = (params) => {
  return axios.get(`${base}/api/KqtTeacherAttendance/GetTeacherMonthDetail`, { params });
};

/**
 * 获取教师个人月历考勤（每日一条）
 */
export const getTeacherMonthRecords = (params) => {
  return axios.get(`${base}/api/KqtTeacherAttendance/GetTeacherMonthRecords`, { params });
};

/**
 * 获取教师原始打卡记录（分页）
 */
export const getTeacherRecordDetail = (params) => {
  return axios.get(`${base}/api/KqtTeacherAttendance/GetTeacherRecordDetail`, { params });
};

/**
 * 获取部门教师日考勤记录（按人×日展开）
 */
export const getTeacherDeptRecords = (params) => {
  return axios.get(`${base}/api/KqtTeacherAttendance/GetTeacherDeptRecords`, { params });
};

/**
 * 获取教师考勤大屏当日汇总
 */
export const getTeacherBigScreenSummary = (params) => {
  return axios.get(`${base}/api/KqtTeacherAttendance/GetTeacherBigScreenSummary`, { params });
};

/**
 * 获取教师考勤大屏趋势（近N天）
 */
export const getTeacherBigScreenTrend = (params) => {
  return axios.get(`${base}/api/KqtTeacherAttendance/GetTeacherBigScreenTrend`, { params });
};

/**
 * 获取教师考勤大屏完整数据（与学生 AttenBigScreen 同结构）
 */
export const getTeacherAttenBigScreenData = (params) => {
  return axios
    .get(`${base}/api/KqtTeacherAttendance/GetTeacherAttenBigScreenData`, { params })
    .then((res) => res.data);
};

/**
 * 导出教师月度考勤明细 Excel
 */
export const exportTeacherMonthDetail = (params) => {
  return axios.get(`${base}/api/KqtTeacherAttendance/ExportTeacherMonthDetail`, {
    params,
    responseType: "blob",
  });
};

/**
 * 导出教师原始打卡记录 Excel（明细列表同条件）
 */
export const exportTeacherRecordDetail = (params) => {
  return axios.get(`${base}/api/KqtTeacherAttendance/ExportTeacherRecordDetail`, {
    params,
    responseType: "blob",
  });
};

/**
 * 导出教师异常考勤统计 Excel（迟到/早退/缺勤）
 */
export const exportTeacherLateRecords = (params) => {
  return axios.get(`${base}/api/KqtTeacherAttendance/ExportTeacherLateRecords`, {
    params,
    responseType: "blob",
  });
};
